import { assert_array_includes, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class ResponseCollectionSpecialInfo extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.RESPONSE_COLLECTION_SPECIAL_INFO;
  /*
   * FIELDS
   */
  workspace_id!: string;
  type!: string;

  images_ids!: string[];

  /*
   * METHODS
   */

  constructor() {
    super();

    this.images_ids = [];
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.workspace_id);

    let collection_types = [...CONSTANTS__shared.WORKSPACE_SPECIAL_COLLECTION_TYPES, ENUM__workspace_entity.COLLECTION_CUSTOM];
    assert_array_includes(collection_types, this.type);
  }
}
